import React, { Component } from 'react'
import bg1 from '../../images/bg_1.jpg'
export default class Freelancer extends Component {
    render() {
        return (
            <>
                <section className="ftco-section ftco-hireme img" >
                    <div className="overlay"></div>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-7 ftco-animate text-center">
                                <h2>I'm <span style={{ color: "black" }}>Available</span> for freelancing</h2>
                                <p>Please let me know to discuss about your business, portfolio, personal, eCommerce, or whatever website developement require.</p>
                                <p className="mb-0" ><a href="mailto:kkimtt1234@gmail.com" className="btn btn-primary py-3 px-5 " style={{ backgroundColor: "black" }}>Contact</a></p>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}
